import axios from 'axios'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')


export const VEHICLE_OWNER_CREATE_URL = `${API_URL}api/v1/definition/vehicleOwner/create`
export const VEHICLE_OWNER_GET_ALL_URL = `${API_URL}api/v1/definition/vehicleOwner/all`
export const VEHICLE_OWNER_DELETE_URL = `${API_URL}api/v1/definition/vehicleOwner/delete/`
export const VEHICLE_OWNER_UPDATE_URL = `${API_URL}api/v1/definition/vehicleOwner/update/`


export function createvehicleOwner(name: string) {
  return axios.post(VEHICLE_OWNER_CREATE_URL, { name })
}

export function loadvehicleOwner(page = 0, size = 10) {
  return axios.get(VEHICLE_OWNER_GET_ALL_URL, {
    params: { page, size },
  })
}
 
export function deletevehicleOwner(id: string) {
  return axios.delete(VEHICLE_OWNER_DELETE_URL + id)
}


export function updatevehicleOwner(id: string, name: string) {
  return axios.patch(VEHICLE_OWNER_UPDATE_URL + id, { name })
}
